import type { FolderNode } from "../../api-client-nswag/custompermission-client";

export type FolderLifecycleStatus = "Not Restricted" | "Modified" | "Saved" | "Scheduled" | "Processing" | "Complete";

export const resolveFolderLifecycleStatus = (
  node: FolderNode,
  isDirty: boolean,
  wasPreviouslyRestricted = false
): FolderLifecycleStatus => {
  const key = (node.publishStatus ?? "").replace(/_/g, " ").trim().toUpperCase();
  const hasPublicationHistory =
    wasPreviouslyRestricted ||
    node.isChanged === true ||
    !!node.scheduledPublishDate ||
    !!node.publishedDate ||
    ["IN PROGRESS", "PROCESSING", "SCHEDULED", "SAVED", "NOT SCHEDULED", "CHANGED", "COMPLETE", "COMPLETED"].includes(key);

  if (node.isRestricted === false && !hasPublicationHistory) return "Not Restricted";
  if (isDirty) return "Modified";

  if (key === "IN PROGRESS" || key === "PROCESSING") return "Processing";
  if (key === "SCHEDULED") return "Scheduled";
  if (key === "SAVED" || key === "NOT SCHEDULED") return "Saved";
  if (key === "COMPLETE" || key === "COMPLETED") return "Complete";

  const hasPendingChanges = key === "CHANGED" || node.isChanged === true;
  if (hasPendingChanges) return "Saved";
  if (node.publishedDate) return "Complete";
  return node.isRestricted || hasPublicationHistory ? "Saved" : "Not Restricted";
};

export const renderTruncatedTextCell = (value: unknown) => {
  const text = String(value ?? "");
  return <span className="mcp-truncate-text" title={text}>{text}</span>;
};

export const applyOverflowTooltipOnCellPrepared = (e: any, cssClass = "cell-text") => {
  if (e?.rowType !== "data") return;
  if (!(e?.column?.cssClass ?? "").includes(cssClass)) return;

  const cellElement = e?.cellElement as HTMLElement | undefined;
  if (!cellElement) return;

  const text = String(e?.displayValue ?? e?.value ?? "").trim();
  if (!text) {
    cellElement.removeAttribute("title");
    return;
  }

  requestAnimationFrame(() => {
    const innerTextElement = cellElement.querySelector(".mcp-truncate-text") as HTMLElement | null;
    const target = innerTextElement ?? cellElement;
    const isOverflowing =
      target.scrollWidth > target.clientWidth ||
      target.scrollHeight > target.clientHeight;

    if (isOverflowing) {
      cellElement.setAttribute("title", text);
    } else {
      cellElement.removeAttribute("title");
    }
  });
};